import {Dimensions, StyleSheet} from 'react-native';
import {getMinHeightImage} from '../../../common/utils/rendering';

const windowDim = Dimensions.get('window').width;
export const styles = StyleSheet.create({
  alignMenu: {
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: 0,
  },
  alignImage: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: getMinHeightImage(),
    aspectRatio: 3,
    backgroundColor: '#9DB6AC',
  },
  detailImagePlaceholder: {
    height: 64,
    width: 64,
  },
  detailImage: {
    flex: 1,
    flexGrow: 1,
    width: '100%',
  },
  title: {
    alignSelf: 'flex-start',
    fontWeight: 'bold',
    marginTop: 0,
    marginBottom: 16,
  },
  descriptionContainer: {
    padding: 16,
    paddingTop: 40,
    paddingBottom: 16,
    // flexGrow: 1,
    backgroundColor: '#fff',
  },
  contentBody: {
    flex: 1,
    maxWidth: windowDim <= 784 ? undefined : '75%',
    flexBasis: '75%',
    margin: 'auto',
  },
  descriptionText: {
    fontSize: 14,
    lineHeight: 18.5,
    marginBottom: 24,
  },
  link: {
    fontSize: 14,
    color: '#0F579E',
    marginBottom: 24,
  },
  decriptionDecoContainer: {
    marginTop: 'auto',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    opacity: 0.6,
  },
  decorImage: {
    width: 200,
    height: 245,
  },
});
